import { useEffect, useState } from 'react';
import { BiWifiOff } from 'react-icons/bi';

import styles from './OfflineIndicator.module.scss';

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) {
    return null;
  }

  return (
    <div className={styles.banner} role="status">
      <BiWifiOff aria-hidden="true" />
      <span>
        Offline — you’re seeing previously loaded data; changes can’t be saved until you’re back
        online.
      </span>
    </div>
  );
};

export default OfflineIndicator;
